<div class="app-version">
	<div
		class="app-version__info"
		[ngClass]="{
			'app-version__info--show': show$$ | async,
		}"
	>
		<button
			class="close"
			(click)="close()"
		></button>
		<p
			class="app-version__info-text"
			appCopyContentOnTouch
			[touchDuration]="0"
		>
			Версия frontend:

			<span class="app-version__info-text-hint"></span>
			<span
				class="app-version__info-text-value"
				appCopyContentOnTouchContent
			>
				{{ frontendBranchName }}
			</span>

			<span class="app-version__info-text-hint"></span>
			<span
				class="app-version__info-text-value"
				appCopyContentOnTouchContent
			>
				{{ frontendVersion }}
			</span>

			<span class="app-version__info-text-hint"></span>
			<span
				class="app-version__info-text-value"
				appCopyContentOnTouchContent
			>
				{{ packageVersion }}
			</span>
		</p>
		<p
			class="app-version__info-text"
			appCopyContentOnTouch
			[touchDuration]="0"
		>
			Версия backend:
			<span
				class="app-version__info-text-value"
				appCopyContentOnTouchContent
			>
				{{ backendVersion | async }}
			</span>
		</p>
	</div>

	<div
		#versionButton
		class="app-version__button"
	></div>
</div>
